import React from 'react';
import { connect } from 'react-redux';
import style from './SelectSection.module.scss';
// import { useHistory } from 'react-router-dom';
import * as actions from '../../../redux/actions/user';
import { IState } from '../../../types/interfaces';
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */

const SelectSection = () => {
  const redirectUser = (section: any) => {
    const sections: any = {
      223: 31,
      44: 2,
      70: 70,
      60: 60,
      80: 80,
    };
    window.location.href = `/api/auth/etp-oauth2?section_id=${sections[section]}`;
  };

  const isELK = process.env.REACT_APP_SELECT_SECTION_80 === 'true';

  return (
    <div className={style.wrapper}>
      <div className={style.auth}>
        <div className={style.authLogo}>
          <div className={style.authLogoImg} />
          <p className={style.authLogoText}>Цифровой помощник</p>
        </div>
        <div className={style.authText}>
          <p className={style.authTextTitle}>Вход в личный кабинет</p>
          <p className={style.authTextDescription}>Выберите секцию площадки для авторизации</p>
        </div>
        <div className={style.authBtnGroup}>
          <button onClick={() => redirectUser(223)} type="button" className={style.btnLink}>
            <span className={style.btnIconSectionCommercial} />
            <span>223-ФЗ и коммерческие закупки</span>
          </button>
          <button onClick={() => redirectUser(44)} type="button" className={style.btnLink}>
            <span className={style.btnIconSectionState} />
            <span>Государственные закупки</span>
          </button>
          <button onClick={() => redirectUser(70)} type="button" className={style.btnLink}>
            <span className={style.btnIconSectionIrao} />
            <span>Интер РАО</span>
          </button>
          <button onClick={() => redirectUser(60)} type="button" className={style.btnLink}>
            <span className={style.btnIconSectionMagazine} />
            <span>Интернет-магазин</span>
          </button>
          {isELK && (
            <button onClick={() => redirectUser(80)} type="button" className={style.btnLink}>
              <span className={style.btnIconSectionCommercial} />
              <span>Единый личный кабинет</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: IState) => ({
  sectionId: state.user.sectionId,
});

export default connect(mapStateToProps, actions)(SelectSection);
